import React from "react";
import forpostLogo from "../assets/forpost-logo.png";

/**
 * Official Forpost wordmark on a high-contrast light surface.
 *
 * Props:
 *   size      - "sm" | "md" | "lg" (controls the wordmark height)
 *   animated  - when true, speed lines dash in on mount
 *   className - extra wrapper classes
 */
const SIZES = {
  sm: "h-8 w-auto sm:h-9",
  md: "h-10 w-auto sm:h-12",
  lg: "h-14 w-auto sm:h-16",
};

export default function Logo({ size = "md", animated = false, className = "" }) {
  const s = SIZES[size] || SIZES.md;

  return (
    <span
      className={`inline-flex items-center rounded-xl border border-white/80 bg-white/95 px-3 py-2 shadow-panel backdrop-blur ${animated ? "animate-fade-in" : ""} ${className}`}
      aria-label="Forpost"
    >
      <img className={s} src={forpostLogo} alt="Forpost" />
    </span>
  );
}
